/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { Button, ButtonProps, Spinner } from 'reactstrap';
import classnames from 'classnames';

interface SubmitButtonProps extends ButtonProps {
  loading?: boolean;
}

const ButtonWithLoader = ({ children, loading, ...rest }: SubmitButtonProps) => {
  return (
    <Button disabled={loading} {...rest} >
      <div className='d-flex align-items-center'>
        {loading ? (
          <Spinner
            className={classnames({
              'position-relative': true,
              'align-self-center': true,
              'mr-1': true,
            })}
            size='sm'
          />
        ) : null}
        {children}
      </div>
    </Button>
  );
};

export default ButtonWithLoader;
